app.service('paymentBox',function(orderConfig) {
	var $self, $listItems, $paymentContent, $paymentList, $paymentDefaultContent, $peselInstalmentToHome, $paymentDescriptions, $instalmentWithAdvisorInfo;
    var defaultView = null, config, selectedItem = null;
	function getElements() {
		$self = $('#payment-content');
		$listItems = $('.payment-item', $self);
        $paymentContent = $('.payment-descriptions', $self);
        $paymentList = $('.payment-list', $self);
        $paymentDefaultContent = $('.default-payment-descriptions', $self);
        $peselInstalmentToHome = $('#peselInstalmentToHome', $self);
        $paymentDescriptions = $('.payment-desc', $self);
		$instalmentWithAdvisorInfo = $('.js-instalments-with-advisor-reminder', $self)
        config = orderConfig.getData();
	}

    function setMinHeight() {
		$paymentContent.css({
			'min-height': $paymentList.height()
		});
	}

    function expandParentList() {
		if (!isDefaultView() && !!selectedItem) {
			//otwiera grupę, jeśli po wczytaniu strony zawiera ona zaznaczone radio
			getListElementById(selectedItem).closest('.items-group').prev().addClass('active');
			addInfoAboutInstalment(selectedItem);
		}
	}

	function addInfoAboutInstalment(paymentId) {
		if (paymentId == 5) {
			$instalmentWithAdvisorInfo.removeClass('none');
		} else {
			$instalmentWithAdvisorInfo.addClass('none');
		}
	}

    function getListElementById(elementId) {
		return $paymentList.find('.payment-item-'+elementId) || false;
	}

	window.getListElementById = getListElementById;

	function setEvents() {
		$listItems.click(setRightContent)
			.mouseover(showRightContent)
			.mouseout(hideOtherContent);

		$('#gift-card-payment-type #gift-card-number').on('paste', function(e){
			var $input = $(this);
			var pasteDigitsOnlyValue = e.originalEvent.clipboardData.getData('text').replace(/[^\d]/gi, '');
			$input.val(pasteDigitsOnlyValue);
		});
	}

    function getValueFromListElementAndCheck(listElement) {
		var $paymentType = $(listElement).find('input.payment-type');
		$paymentType.prop('checked', true);
		return $paymentType.val();
	}

	function showListItemByNumber(itemNumber) {
		$paymentDescriptions.removeClass('active').filter('#payment-desc-'+itemNumber).addClass('active');
	}

	function isItemActive(itemElement) {
		return $(itemElement).hasClass('activ');
	}

	function showMessage(itemId) {
		if(typeof itemId == 'undefined'){
			if(paymentTypeCode){
				showMessage(paymentTypeCode);
				return;
			}

			$paymentContent.removeClass('active');
			$paymentDefaultContent.addClass('active');

			$listItems.removeClass('activ');

		} else {
			$paymentContent.addClass('active');
			$paymentDefaultContent.removeClass('active');

			if (itemId == 6) {
				$peselInstalmentToHome.show();
			} else {
				$peselInstalmentToHome.hide();
			}

			$('.payment-desc', $paymentContent).not('#payment-desc-'+itemId).removeClass('active');
			$('#payment-desc-'+itemId).addClass('active');

			$listItems.removeClass('activ');
			$paymentList.find('.payment-item-'+itemId).addClass('activ');
		}
	}
    function getOrderSummaryAjax(paymentType) {
		var data = config.supplementPayment ? {supplementPaymentTypeCode: paymentType} : {paymentTypeCode: paymentType, refresh:true};
		$.ajax({
			url: '/order-path-payment-select-payment-type.ltr',
			cache: false,
			async: false,
			dataType : 'json',
			type: 'POST',
			data: data,
			success: function(json){
				standardCartPreviewForOrderPathSuccess(json);
			}
		});
	}

    function showRightContent() {

		var inputValue = getValueFromListElement(this);
		setMinHeight();

		if (!isItemActive(this)) {
			$paymentContent.addClass('potential-choice');
		}

		$paymentList.addClass('list-element-hovered');

		if (isDefaultView()) {
			$paymentContent.addClass('active');
			$paymentDefaultContent.removeClass('active');
		}

		showListItemByNumber(inputValue);
	}

    function isDefaultView() {
		return defaultView;
	}
    function setDefaultFlag(bool) {
		defaultView = bool;
	}

    function setRightContent(event) {
		if (!$(this).find('input').prop('disabled')) {

			var inputValue = getValueFromListElementAndCheck(this);
			//funkcje z cart.js zdefiniowane globalnie
			setCurrent();
			selectPaymentTypeInCart(inputValue);		// ustawia przełaczanie różnych elementów
			
			showMessage(inputValue);
			refreshHolidayPromotionBeforeDeliveryTimeStage();
			addInfoAboutInstalment(inputValue);

			getOrderSummaryAjax(inputValue);

			setDefaultFlag(false);
			$paymentContent.removeClass('potential-choice');

			//Potrzebne do przywrócenia treści prawego panelu po mouseover elementu.
			selectedItem = inputValue;
		} else {
			event.preventDefault();
		}
	}

    function setValues() {
		//Ustawia flagę kontentu bazowego w przypadku jeśli żaden element listy nie jest pierwotnie zaznaczony
		setDefaultFlag(
			!setSelectedItemNumber()
		);
	}

    function getValueFromListElement(listElement) {
		var $paymentType = $(listElement).find('input.payment-type');
		return $paymentType.val();
	}

    function setSelectedItemNumber() {
		//Ustawia numer id aktywnego elementu listy. Potrzebne do wyświetlenia pierwszego aktywnego prawego kontentu.
		var activeElementValue = getValueFromListElement($('.payment-item.activ', $self));
		selectedItem = activeElementValue;

		return !!activeElementValue;
	}

    function hideOtherContent() {
		$paymentContent.removeClass('potential-choice');
		$paymentList.removeClass('list-element-hovered');

		if (isDefaultView()) {
			$paymentContent.removeClass('active');
			$paymentDefaultContent.addClass('active');
		}

		showListItemByNumber(selectedItem);
	}

    function preactivadePaymentDescription(code) {
		$paymentContent.find('#payment-desc-'+code, $self).addClass('active');
	}
	
	function init() {
		console.log('INIT PAYMENT Content');
		getElements();
		setEvents();
        setValues();
        setMinHeight();
        expandParentList();

		if (config.activeCode) {
			// na potrzeby chrome dodany timeout, w przeciwnym wypadku nie wyswietli sie opis
			// sposobu platnosci przy ladowaniu strony
			setTimeout(function () {
				if (config.supplementPayment && config.supplementPaymentCode) {
					preactivadePaymentDescription(config.supplementPaymentCode);
					startPayment(config.supplementPaymentCode); 		// wywołuje globalną funkcje
				} else {
					preactivadePaymentDescription(config.activeCode);
					startPayment(config.activeCode);					// wywołuje globalną funkcje
				}
			 }, 1);
		}
		if ($paymentContent.hasClass('active')) {
			setDefaultFlag(false);
			selectedItem = $paymentList.find('.activ input').val();
		}
	}

	return {
		init
	};
});
